import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { localizeDate } from '@/utils/date';
const initialState = {
  activationPrompt: false,
  integrationToActivate: null,
  integrations: [{
    type: 'influxdb',
    isEnabled: false
  }, {
    type: 'grafana',
    isEnabled: false
  }, {
    type: 'states_influxdb',
    isEnabled: false
  }, {
    type: 'iec104',
    isEnabled: false
  }, {
    type: 'iec104_push',
    isEnabled: false
  }]
};
export default {
  name: 'CoreTenantDetailsIntegrations',
  props: {
    accountId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return cloneDeep(initialState);
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  },
  watch: {
    accountId() {
      this.resetData();
      return this.fetchIntegrations();
    }
  },
  mounted() {
    this.resetData();
    return this.fetchIntegrations();
  },
  methods: {
    get,
    set,
    resetData() {
      Object.assign(this.$data, cloneDeep(initialState));
    },
    fetchIntegrations() {
      if (this.accountId) {
        ApiService.getVersionDriftAccountIntegrations(this.accountId).then(res => {
          const integrationMap = (res || []).filter(val => initialState.integrations.findIndex(i => i.type === val.type) >= 0).reduce((acc, val) => {
            val.isEnabled = true;
            acc[val.type] = val;
            return acc;
          }, {});
          this.integrations = this.integrations.map(integration => {
            return integrationMap[integration.type] || {
              type: integration.type,
              isEnabled: false
            };
          });
        }).catch(err => console.error(err));
      }
    },
    confirmActivation(integration) {
      this.integrationToActivate = integration;
      this.activationPrompt = true;
    },
    cancelActivation() {
      this.integrationToActivate.isEnabled = false;
      this.integrationToActivate = null;
      this.activationPrompt = false;
    },
    activate(integration) {
      this.integrationToActivate = null;
      this.activationPrompt = false;
      ApiService.enableVersionDriftAccountIntegration(this.accountId, integration.type).then(() => {
        this.$snack(this.$i18n_t('accMgmt.tenant.integrations.activationSuccess'), 'success');
        return this.fetchIntegrations();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
        integration.isEnabled = false;
      });
    },
    localizeDate(item) {
      return localizeDate(item);
    }
  }
};